import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';
//import PropTypes from 'prop-types';
import Button from 'material-ui/Button';

import * as sessionActions from 'actions/session';

class Logout extends React.Component {
    /*static propTypes = {
        history: PropTypes.object.isRequired
    }*/

    handleLogout = () => {
        this.props.sessionActions.logout();
    }

    render() {
        if (this.props.session && !this.props.session.isAuthenticated) {
            return <Redirect to='/login' />;
        }

        return (
            <Button color="inherit" onClick={this.handleLogout}>
                Logout
			</Button>
        )
    }
}

const mapStateToProps = (state, props) => ({
    session: state.session
});

const mapDispatchToProps = dispatch => ({
    sessionActions: bindActionCreators(sessionActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
